import { Grid, styled, Typography } from "@mui/material";

const Root = styled(Grid)(({ theme }) => ({
	height: "40vh",
	padding: theme.spacing(4),
	textAlign: "center",
	backgroundColor: theme.palette.background.paper,
}));

export interface EmptyTabProps {
	name: string;
}

export const EmptyTab = ({ name }: EmptyTabProps): JSX.Element => (
	<Root container alignItems="center" justifyContent="center">
		<Typography variant="h4">
			There isn&apos;t any data yet for {name} 😔
		</Typography>
	</Root>
);
